<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.companySettings') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{ $ml.get('shared.settings') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.companySettings') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-3">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('companySettings.companies') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0" type="button" class="btn btn-sm btn-warning " @click="newCompany()">{{
                  $ml.get('companySettings.newCompany') }}</button>
              </div>
            </div>
            <div class="box-body">
              <div v-show="companyList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="company2 in companyList" :key="company2.id">
                      <td>{{ company2.name }}</td>
                      <td class="pull-right">
                        <button type="button" class="btn btn-primary btn-sm" @click="getCompany(company2.id)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="companyList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{ $ml.get('companySettings.companyNotRecord') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-4">
              <div class="box box-primary">
                <div class="box-header">
                  <h3 class="box-title">
                    <span>{{ $ml.get('companySettings.companyLogo') }}</span>
                  </h3>
                </div>
                <div class="box-body box-profile" align="center">
                  <img
                    :src="(this.company.logo == null && this.tempUrl == null) || (this.company.logo == '' && this.tempUrl == null) ? '/src/assets/default-company.png' : this.company.logo || this.tempUrl"
                    class="profile-user-img img-responsive img-circle" style="height: 150px; width: 150px;" />
                  <a href="#" v-show="this.tempUrl || this.company.logo" @click="removeImage()" class="text-red">
                    <i class="fa fa-remove"></i> {{ $ml.get('general.remove') }}
                  </a>
                  <hr />
                  <my-upload field="img" @crop-success="cropSuccess" langType="tr" v-model="showImageDialog"
                    :width="300" :height="300" url="/images" :params="params" :headers="headers"
                    img-format="png"></my-upload>
                  <button type="button" @click="toggleShow()" class="btn btn-primary btn-sm" style="width:100%">
                    <i class="fa fa-upload"></i> {{ $ml.get('companySettings.selectPhoto') }}
                  </button>
                </div>
                <div class="overlay" id="load" :hidden="!isLoadingDetail">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
              </div>
              <div class="box box-primary" v-show="modules.visitor">
                <div class="box-header">
                  <h3 class="box-title">{{ $ml.get('companySettings.visitorSettings') }}</h3>
                </div>
                <div class="box-body">
                  <div class="form-group">
                    <label>{{ $ml.get('companySettings.cardIsNotUsedAccessGroup') }}</label>
                    <select @change="changeZTKartBosYetki($event)" class="form-control">
                      <option :selected="ztkartBosYetki == 0" value="0">{{ $ml.get('general.select') }}</option>
                      <option v-for="aG in accessGroupList" :key="aG.id" :value="aG.id"
                        :selected="ztkartBosYetki == aG.id">{{ aG.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('companySettings.cardIsUsedAccessGroup') }}</label>
                    <select @change="changeZTKartYetki($event)" class="form-control">
                      <option :selected="ztkartYetki == 0" value="0">{{ $ml.get('general.select') }}</option>
                      <option v-for="aG in accessGroupList" :key="aG.id" :value="aG.id"
                        :selected="ztkartYetki == aG.id">{{ aG.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <button @click="setSetting()" type="button" class="btn btn-success btn-sm " style="width:100%;">{{
                      $ml.get('general.save') }}</button>
                  </div>
                </div>
                <div class="overlay" id="load" :hidden="!isLoadingSetting">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="nav-tabs-custom">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#sirket-bilgileri" data-toggle="tab" aria-expanded="true">
                      <span>{{ $ml.get('companySettings.companyInformation') }}</span>
                    </a>
                  </li>
                  <li>
                    <a href="#zorunlu-alanlar" data-toggle="tab" aria-expanded="true">Zorunlu Alanlar</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="sirket-bilgileri">
                    <div class="form-group">
                      <label>{{ $ml.get('companySettings.companyName') }}</label>
                      <input v-model="company.name" type="text" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('companySettings.companyTitle') }}</label>
                      <input v-model="company.title" type="text" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('companySettings.phone') }}</label>
                      <input v-model="company.phoneNumber" type="text" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('companySettings.webSite') }}</label>
                      <input v-model="company.website" type="text" class="form-control" placeholder />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('companySettings.address') }}</label>
                      <input v-model="company.address" type="text" class="form-control" placeholder />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('companySettings.syncRegistrationNoToDeviceNo') }}</label>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="company.setSicilNoToTerminalNo"
                            @change="company.setSicilNoToTerminalNo == true ? company.setSicilNoToTerminalNo = false : company.setSicilNoToTerminalNo = true"
                            type="checkbox" />
                          {{ $ml.get('companySettings.syncRegistrationNoToDeviceNo') }}
                        </label>
                      </span>
                    </div>
                  </div>
                  <div class="tab-pane" id="zorunlu-alanlar">
                    <span class="form-control checkbox" v-for="field in fields" :key="field.name" :title="field.disabled ? 'Değiştirilemez' : ''">
                      <label style="margin-left:20px;">
                        <input :checked="field.isChecked"
                          @change="field.isChecked = !field.isChecked"
                          type="checkbox" :disabled="field.disabled" />
                        {{ field.label }} ({{ field.name }})
                      </label>
                    </span>
                  </div>
                  <div class="overlay" id="load" :hidden="!isLoadingDetail">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-footer">
                    <div class="pull-right">
                      <button v-show="!isNewCompany && authControl == 0" type="button" data-toggle="modal"
                        data-target="#modal-sil" class="btn btn-sm btn-danger " style="margin: 5px; width:120px;">{{
                          $ml.get('general.delete') }}</button>
                      <button v-show="isNewCompany && authControl == 0" type="button" data-toggle="modal"
                        data-target="#modal-kaydet" class="btn btn-sm btn-success " style="margin: 5px; width:120px;">{{
                          $ml.get('general.save') }}</button>
                      <button v-show="!isNewCompany && authControl == 0" type="button" data-toggle="modal"
                        data-target="#modal-guncelle" class="btn btn-sm btn-success "
                        style="margin: 5px; width:120px;">{{
                          $ml.get('general.update') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.company.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('companySettings.isContinueCompanyUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveCompany()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.company.name }}</p>
              <span>{{ $ml.get('companySettings.isContinueCompanySave') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveCompany()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.company.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('companySettings.isContinueCompanyDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteCompany()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
import myUpload from "vue-image-crop-upload";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isLoadingSetting: false,
      fields: [
        { name: "sicilNo", label: this.$ml.get('employees.registrationNumberInfo'), isChecked: true, disabled: true },
        { name: "name", label: this.$ml.get('employees.nameSurname'), isChecked: true, disabled: true },
        { name: "title", label: this.$ml.get('employees.title'), isChecked: false, disabled: false },
        { name: "departmentId", label: this.$ml.get('employees.department'), isChecked: true, disabled: true },
        { name: "identityNo", label: this.$ml.get('employees.citizenshipNumber'), isChecked: false, disabled: false },
        { name: "startDate", label: this.$ml.get('employees.dateOfStartWorkInfo'), isChecked: true, disabled: true },
        { name: "endDate", label: this.$ml.get('employees.dateOfEndWork'), isChecked: false, disabled: false },
        { name: "workGroupId", label: this.$ml.get('employees.workPlan'), isChecked: false, disabled: false },
        { name: "stateId", label: this.$ml.get('employees.state'), isChecked: false, disabled: false },
        { name: "stateNote", label: this.$ml.get('employees.stateNote'), isChecked: false, disabled: false },
        { name: "terminalNo", label: this.$ml.get('employees.deviceEmployeeNumber'), isChecked: true, disabled: true },
        { name: "statuId", label: this.$ml.get('employees.status'), isChecked: false, disabled: false },
        { name: "cardNo", label: this.$ml.get('employees.deviceCardNo'), isChecked: false, disabled: false },
        { name: "terminalStatu", label: this.$ml.get('employees.deviceStatus'), isChecked: false, disabled: false },
        { name: "terminalPassword", label: this.$ml.get('employees.devicePassword'), isChecked: false, disabled: false },
        { name: "tzCode", label: "Timezone", isChecked: false, disabled: false },
        { name: "plateNo", label: this.$ml.get('employees.plateNo'), isChecked: false, disabled: false },
        { name: "hgsNo", label: this.$ml.get('employees.hgsNo'), isChecked: false, disabled: false },
        { name: "documentNo", label: this.$ml.get('employees.documentNo'), isChecked: false, disabled: false },
      ],
      company: {
        id: null,
        name: "",
        logo: null,
        website: "",
        phoneNumber: "",
        address: "",
        title: "",
        setSicilNoToTerminalNo: false
      },
      ztkartBosYetki: null,
      ztkartYetki: null,
      isNewCompany: true,
      companies: [],
      accessGroups: [],
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {}
    };
  },
  components: {
    "my-upload": myUpload
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    companyList() {
      return this.companies;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    changeZTKartYetki(event) {
      this.ztkartYetki = event.target.value;
    },
    changeZTKartBosYetki(event) {
      this.ztkartBosYetki = event.target.value;
    },
    toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.company.logo = null;
    },
    newCompany() {
      this.isLoadingDetail = true;
      this.isNewCompany = true;
      this.company.id = null;
      this.company.name = "";
      this.company.logo = null;
      this.company.website = "";
      this.company.phoneNumber = "";
      this.company.address = "";
      this.company.title = "";
      this.company.setSicilNoToTerminalNo = false;
      this.imageData = null;
      this.tempUrl = null;
      this.isLoadingDetail = false;
    },
    async deleteCompany() {
      try {
        this.isLoadingDetail = true;
        let id = this.company.id;
        const response = await this.$axios
          .delete("/CompanySettings/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getCompanies();
        this.newCompany();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },

    async saveCompany() {
      if (this.company.name == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterACompanyName'));
        return;
      }
      var requiredFields = [];
      this.fields.forEach(field => {
        if (field.isChecked) {
          requiredFields.push(field.name);
        }
      });
      if (this.isNewCompany) {
        this.isLoadingDetail = true;
        try {
          let company2 = this.company;
          let image = this.imageData;
          const response = await this.$axios
            .post("/CompanySettings", {
              name: company2.name,
              website: company2.website,
              phoneNumber: company2.phoneNumber,
              address: company2.address,
              title: company2.title,
              setSicilNoToTerminalNo: company2.setSicilNoToTerminalNo,
              requiredFields: requiredFields
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.sirketId;
          if (this.imageData) {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("file", image);
            if (this.imageData != null) {
              const responseImage = await this.$axios.post(
                "/CompanySettings/AddCompanyLogo/" + id,
                formData
              );
            }
          }
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getCompanies();
          this.getCompany(id);
          this.isNewCompany = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let company2 = this.company;
          let image = this.imageData;
          const response = await this.$axios
            .post("/CompanySettings/" + company2.id, {
              name: company2.name,
              website: company2.website,
              phoneNumber: company2.phoneNumber,
              address: company2.address,
              title: company2.title,
              setSicilNoToTerminalNo: company2.setSicilNoToTerminalNo,
              requiredFields: requiredFields
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = company2.id;
          if (this.imageData) {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("file", image);
            const responseImage = await this.$axios.post(
              "/CompanySettings/AddCompanyLogo/" + id,
              formData
            );
          } else if (this.company.logo == null) {
            const responseImage = await this.$axios.patch(
              "/CompanySettings/RemoveLogo/" + id
            );
          }
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getCompanies();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async setSetting() {
      try {
        this.isLoadingSetting = true;
        let company2 = this.company;
        const response = await this.$axios
          .post("/CompanySettings/UpdateCompanyVisitorSettings", {
            ztkartBosYetki: this.ztkartBosYetki,
            ztkartYetki: this.ztkartYetki,
            sirketId: company2.id
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingSetting = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingSetting = false;
                return;
              }
            }
          });
        this.isLoadingSetting = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoadingSetting = false;
      }
    },
    async getSetting(id) {
      try {
        this.isLoadingSetting = true;
        const response = await this.$axios
          .get("CompanySettings/GetCompanyVisitorSettings?companyId=" + id)
          .then(response => {
            this.ztkartBosYetki = response.data.ztkartBosYetki;
            this.ztkartYetki = response.data.ztkartYetki;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingSetting = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingSetting = false;
                return;
              }
            }
          });
        this.isLoadingSetting = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingSetting = false;
      }
    },
    async getCompany(id) {
      try {
        this.isLoadingDetail = true;
        this.newCompany();
        const response = await this.$axios
          .get("/CompanySettings/" + id)
          .then(response => {
            this.isNewCompany = false;
            this.company.id = id;
            this.company.name = response.data.name;
            this.company.logo = response.data.logo;
            this.company.website = response.data.website;
            this.company.phoneNumber = response.data.phoneNumber;
            this.company.address = response.data.address;
            this.company.title = response.data.title;
            this.company.setSicilNoToTerminalNo =
              response.data.setSicilNoToTerminalNo;
              this.fields.forEach(field => {
                if (response.data.requiredFields.includes(field.name)) {
                  field.isChecked = true;
                } else {
                  field.isChecked = false;
                }
              });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        await this.getSetting(id);
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async getCompanies() {
      try {
        this.isLoading = true;
        const companies = [];
        const response = await this.$axios
          .get("/CompanySettings")
          .then(response => {
            response.data.forEach(doc => {
              companies.push({
                id: doc.id,
                name: doc.name,
                logo: doc.logo,
                website: doc.website,
                phoneNumber: doc.phoneNumber,
                address: doc.address,
                title: doc.title,
                setSicilNoToTerminalNo: doc.setSicilNoToTerminalNo
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.companies = companies;
        if (companies.length > 0) {
          this.getCompany(companies[0].id);
          this.getSetting(companies[0].id);
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAccessGroups() {
      try {
        this.isLoading = true;
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage')
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getCompanies();
    await this.getAccessGroups();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/companySettings/CompanySettings.vue